import { COLORS } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled, { css } from 'styled-components';

interface StyledProps {
  isInlineControl?: boolean;
  stacksWhenNarrow?: boolean;
}

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  max-width: 100%;
  width: 100%;
  gap: 5rem;

  // Sharing a line with the question name means this cell must size to its
  // control: left at width: 100% it claims the whole row and squeezes the name
  // down to one word per line.
  ${(props: StyledProps) =>
    props.isInlineControl &&
    css`
      width: auto;
      max-width: 100%;
      flex: 0 1 auto;
      margin-left: auto;
      gap: 0;

      // Taking the full width from smallTablet down pushes this cell onto its
      // own line under the question name. align-items: flex-end above keeps the
      // control right aligned there, which a plain wrap would not: a wrapped
      // shrink-to-fit cell sits at the left of the row.
      ${(inner: StyledProps) =>
        inner.stacksWhenNarrow &&
        css`
          ${respondTo.smallTablet`
            width: 100%;
          `};
        `};
    `};
`;

export const ErrorContainer = styled.div`
  align-self: flex-end;
`;

export const ADDITIONAL_WRAPPER_MIN_HEIGHT = 15;
export const AdditionalWrapper = styled.div`
  min-height: ${ADDITIONAL_WRAPPER_MIN_HEIGHT}rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;

  // On a shared line the reserved height is dead space under the control, so it
  // is only claimed once there is an error or a price to show.
  ${(props: StyledProps) =>
    props.isInlineControl &&
    css`
      min-height: 0;
      width: auto;

      &:not(:empty) {
        margin-top: 5rem;
      }
    `};
`;

export const ErrorMessage = styled.div`
  font-weight: 400;
  font-size: 12rem;
  line-height: 10rem;
  color: ${COLORS.RED_100};
`;

export const AutoSetMessage = styled.div`
  font-weight: 400;
  font-size: 12rem;
  line-height: 10rem;
  color: ${COLORS.BLACK};
  font-style: italic;
  align-self: flex-start;
`;

export const PriceContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5rem;
  align-self: flex-end;
`;

export const PriceLabel = styled.label`
  color: ${COLORS.BLACK};
  font-weight: 400;
  font-size: 13rem;
  line-height: 10rem;
`;

export const PriceValue = styled(PriceLabel)`
  color: ${COLORS.GREEN};
`;
